/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const o = "data-keyboardnavlevel", a = "data-keyboardnavscope", t = "data-keyboardnavheader", A = "data-keyboardnavbody", e = "data-keyboardnavid", _ = "data-keyboardnavzone", d = "_filter", n = "k-grid-cancel-command", r = "k-grid-edit-command", D = {
  [a]: !0
}, c = {
  [t]: !0
}, E = {
  [A]: !0
};
export {
  n as KEYBOARD_NAV_CANCEL_BUTTON_CLASS,
  A as KEYBOARD_NAV_DATA_BODY,
  t as KEYBOARD_NAV_DATA_HEADER,
  e as KEYBOARD_NAV_DATA_ID,
  o as KEYBOARD_NAV_DATA_LEVEL,
  a as KEYBOARD_NAV_DATA_SCOPE,
  _ as KEYBOARD_NAV_DATA_ZONE,
  r as KEYBOARD_NAV_EDIT_BUTTON_CLASS,
  d as KEYBOARD_NAV_FILTER_COL_SUFFIX,
  E as tableKeyboardNavigationBodyAttributes,
  c as tableKeyboardNavigationHeaderAttributes,
  D as tableKeyboardNavigationScopeAttributes
};
